// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const marowak_alola: PokeData = {
  "id": 10115,
  "name": "marowak-alola",
  "height": 10,
  "weight": 340,
  "base_experience": 149,
  "types": [
    PokeType.FIRE,
    PokeType.GHOST
  ],
  "api_moves": [
    "swords-dance",
    "headbutt",
    "thrash",
    "double-edge",
    "tail-whip",
    "leer",
    "growl",
    "fire-spin",
    "rage",
    "screech",
    "focus-energy",
    "bone-club",
    "bonemerang",
    "flame-wheel",
    "mud-slap",
    "bone-rush",
    "false-swipe",
    "will-o-wisp",
    "endeavor",
    "fling",
    "flare-blitz",
    "hex",
    "retaliate",
    "stomping-tantrum",
    "shadow-bone"
  ],
  "moves": [
    "headbutt",
    "leer",
    "growl",
    "fire-spin",
    "bonemerang",
    "mud-slap",
    "flare-blitz",
    "spectral-snatch",
    "fire-punch",
    "night-shade",
    "magma-storm",
    "flamethrower",
    "fire-ball"
  ],
  "evolution_chain": {
    "id": 46,
    "item": null,
    "species": [
      {
        "name": "cubone",
        "order": 113,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "marowak",
        "order": 114,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 104,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 153,
    "speed": 89,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
